import CICoordinatorPage from "./CICoordinatorPage";

/** Relay and coordinator entry points share one task-first service page. */
export default function RelayPage() {
  return <CICoordinatorPage />;
}
